require('./_model-search.scss')

const ModelSearch = {

    init: function (element) {
        const _ = this
        _.el = element
        _.openFiltersBtn = element.querySelector('#model-filters-open-button')
        _.closeFiltersBtn = element.querySelector('#model-filters-close-button')
        _.filterFlyout = element.querySelector('#model-filters-flyout')
        _.filterFlyoutBg = element.querySelector('#model-filters-flyout-bg')
        _.isFlyoutShown = false

        this.openFiltersBtn.addEventListener('click', (e)=> {
            e.currentTarget.attributes['aria-expanded'].value = true
            this.filterFlyout.attributes['aria-hidden'].value = false
            this.el.classList.add('flyout')
            this.filterFlyout.focus()
            this.isFlyoutShown = true
        })
        this.closeFiltersBtn.addEventListener('click', (e)=> {
            this.openFiltersBtn.attributes['aria-expanded'].value = false
            this.filterFlyout.attributes['aria-hidden'].value = true
            this.el.classList.remove('flyout')
            this.isFlyoutShown = false
            this.openFiltersBtn.focus()
        })
        this.filterFlyoutBg.addEventListener('click', (e) => {
            if(this.isFlyoutShown) {
                this.closeFiltersBtn.click()
            }
        })
        _.trap_focus(this.filterFlyout)
    },
    trap_focus: (target) => {
        const KEYCODE_TAB = 9
        const focusableElsSelectors = `
        #model-filters-close-button, button.drawer__item-button,
        .drawer__item.active button:not([disabled]), .drawer__item.active input[type="checkbox"]:not([disabled]),
        button.inventory-search-page__filter-apply, button.inventory-search-page__filter-clear-all
        `
        const focusableEls = target.querySelectorAll(focusableElsSelectors)
        const firstFocusableEl = focusableEls[0]
        const lastFocusableEl = focusableEls[focusableEls.length - 1]
        target.addEventListener('keydown', (e) => {
            const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB)

            if (!isTabPressed) {
              return;
            }

            if ( e.shiftKey ) /* shift + tab */ {
              if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                  e.preventDefault();
                }
              } else /* tab */ {
              if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                  e.preventDefault();
                }
              }
        })

    }

}

export default ModelSearch
